import React, { useState } from "react";
import { useFormik } from "formik";
import SelectDistributorModal from "./SelectDistributorModal";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";



const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "14px",
};

const rowStyle = {
  display: "flex",
  gap: "20px",
  flexWrap: "wrap",
};

const groupStyle = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
 
};

const inputStyle = {
  padding: "8px",
  borderRadius: "5px",
  border: "1px solid #dedede",
  fontSize: "13px",
  
};

const sectionLabel = {
  fontSize: "14px",
  color: "#1d1d1dff",
  fontWeight: "700",
};

const radioContainer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid #dedede",
  borderRadius: "6px",
  padding: "8px 12px",
  backgroundColor: "#fff",
};

const radioGroup = {
  display: "flex",
  gap: "18px",
  alignItems: "center",
};

const checkboxContainer = {
  ...inputStyle,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  backgroundColor: "#fff",
  cursor: "pointer",
};

const OrderbookForm = () => {
  const formik = useFormik({
    initialValues: {
      shortageCalc: "consider",
      minStockCalc: "",
      maxStockCalc: "",
      overrideValues: false,
      minStockUser: "",
      maxStockUser: "",
      preferredDistributor: "",
    },
    onSubmit: (values) => {
      console.log("Orderbook Data:", values);
    },
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDistributorSelect = (name) => {
  formik.setFieldValue("preferredDistributor", name);
  setIsModalOpen(false);
};

  return (
    <form style={formStyle} onSubmit={formik.handleSubmit}>
      {/* SHORTAGE CALCULATION */}
      <div style={groupStyle}>
  {/* <label style={sectionLabel}>SHORTAGE CALCULATION</label> */}

  <div
    style={{
      ...inputStyle,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#fff",
      cursor: "pointer",
    }}
    tabIndex={0} // make it focusable for keyboard navigation
    onKeyDown={(e) => {
      if (e.key === "ArrowRight") {
        formik.setFieldValue("shortageCalc", "ignore");
      } else if (e.key === "ArrowLeft") {
        formik.setFieldValue("shortageCalc", "consider");
      }
    }}
  >
    <span style={sectionLabel}>
      Shortage Calculation
    </span>
    <div style={{ display: "flex", gap: "18px", alignItems: "center" }}>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
        }}
      >
        <input
          type="radio"
          name="shortageCalc"
          value="consider"
          checked={formik.values.shortageCalc === "consider"}
          onChange={formik.handleChange}
          style={{ accentColor: "#6c0aad", cursor: "pointer" }}
        />
        <span style={{ fontSize: "14px", color: "#1f1e1eff" }}>Consider</span>
      </label>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
        }}
      >
        <input
          type="radio"
          name="shortageCalc"
          value="ignore"
          checked={formik.values.shortageCalc === "ignore"}
          onChange={formik.handleChange}
          style={{ accentColor: "#6c0aad", cursor: "pointer" }}
        />
        <span style={{ fontSize: "14px", color: "#1f1e1eff" }}>Ignore</span>
      </label>
    </div>
  </div>

 <span style={{ fontSize: "12px", color: "#666", marginTop: "4px", display: "flex", alignItems: "center", gap: "6px" }}>
  Use Arrow Keys
  <FiArrowLeft style={{ fontSize: "14px" }} />
  <FiArrowRight style={{ fontSize: "14px" }} />
  to switch
</span>
</div>

      {/* MIN & MAX STOCK (CALCULATED) */}
      <div style={rowStyle}>
          <div style={groupStyle}>
          <label style={{ fontSize:"14px"}}>Min Stock (Calculated)</label>
          <div
            style={{
              padding: "2px 10px 2px 4px",
              borderRadius: "5px",
              border: "1px solid #dedede",
              fontSize: "13px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#fdfdfdff",
              
             
            }}
          >
            <input
              type="text"
              name="minStockCalc"
              placeholder="Enter value"
              style={{
                border: "none",
                outline: "none",
                fontSize: formik.values.minStockCalc ? "15px" : "13px",
                color: formik.values.minStockCalc ? "#000000ff" : "#333",
                flex: 1,
                backgroundColor: "transparent",
                width: "100%",
              }}
              value={formik.values.minStockCalc}
              onChange={formik.handleChange}
            />
            <span style={{ color: "#999", fontSize: "12px", whiteSpace: "nowrap" }}>
              ~ 13 days
            </span>
          </div>
        </div>

        <div style={groupStyle}>
        <label style={{ fontSize:"14px"}}>Max Stock (Calculated)</label>
        <div
          style={{
             padding: "2px 10px 2px 4px",
             borderRadius: "5px",
             border: "1px solid #dedede",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#fdfdfdff",
              
          }}
        >
          <input
            type="text"
            name="maxStockCalc"
            placeholder="Enter value"
            style={{
              border: "none",
              margin:"0px",
              outline: "none",
              fontSize: formik.values.maxStockCalc ? "15px" : "13px",
                color: formik.values.maxStockCalc ? "#000000ff" : "#333",
              flex: 1,
              backgroundColor: "transparent",
               width: "100%",
            }}
            value={formik.values.maxStockCalc}
            onChange={formik.handleChange}
          />
          <span style={{ color: "#999", fontSize: "12px", whiteSpace: "nowrap" }}>
            ~ 14 days
          </span>
        </div>
      </div>

      </div>

      {/* OVERRIDE CHECKBOX */}
      <div style={groupStyle}>
        <div
          style={checkboxContainer}
          onClick={() =>
            formik.setFieldValue("overrideValues", !formik.values.overrideValues)
          }
        >
          <input
            type="checkbox"
            name="overrideValues"
            checked={formik.values.overrideValues}
            onChange={formik.handleChange}
            style={{
              width: "16px",
              height: "16px",
              accentColor: "#6c0aad",
              cursor: "pointer",
            }}
          />
          <span style={{ fontSize: "13px", color: "#333" }}>
            Override Max & Min Stock Calculated Values
          </span>
        </div>
      </div>

      {/* USER DEFINED STOCK */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize:"14px"}}>Min Stock (User-Defined)</label>
          <input
            type="text"
            name="minStockUser"
            placeholder="Enter Min Stock"
            style={{...inputStyle,
              fontSize: formik.values.minStockUser ? "15px" : "13px",
                color: formik.values.minStockUser ? "#000000ff" : "#333",
            }}
            value={formik.values.minStockUser}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize:"14px"}}>Max Stock (User-Defined)</label>
          <input
            type="text"
            name="maxStockUser"
            placeholder="Enter Max Stock"
            style={{...inputStyle,
              fontSize: formik.values.maxStockUser ? "15px" : "13px",
                color: formik.values.maxStockUser ? "#000000ff" : "#333",
            }}

            value={formik.values.maxStockUser}
            onChange={formik.handleChange}
          />
        </div>
      </div>

      {/* PREFERRED DISTRIBUTOR */}
      <div style={groupStyle}>
  <label style={{ fontSize:"14px"}}>
    Preferred Distributor <span style={{ color: "#888", fontSize:"14px",}}>(Optional)</span>
  </label>
  <input
    type="text"  
    name="preferredDistributor"
    placeholder="Select Distributor"
    style={{padding: "8px",
        borderRadius: "5px",
        border: "1px solid #dedede",
        fontSize: formik.values.preferredDistributor ? "15px" : "13px",
                color: formik.values.preferredDistributor ? "#000000ff" : "#333",

        cursor:"pointer",}}
          
    value={formik.values.preferredDistributor}
    
    onClick={() => setIsModalOpen(true)}
  />
</div>

<SelectDistributorModal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  onSelectDistributor={handleDistributorSelect}
/>
    </form>
  );
};

export default OrderbookForm;
